<template>
  <div>
    <v-row>
      <v-col cols="6">
        <v-row>
          <v-col cols="12">
            <div class="panel pa-3">
              <v-row class="pb-0 pt-2">
                <v-col cols="3" class="pt-0 pb-0">
                  Model:
                </v-col>
                <v-col cols="9" class="pt-0 pb-0">
                  {{ firmwareDetails.device_model }}
                </v-col>
              </v-row>

              <v-row class="pb-0">
                <v-col cols="3" class="pt-0 pb-0">
                  FW Version:
                </v-col>
                <v-col cols="9" class="pt-0 pb-0">
                  {{ firmwareDetails.fw_build_version }}
                </v-col>
              </v-row>

              <v-row class="pb-0">
                <v-col cols="3" class="pt-0 pb-0">
                  Status:
                </v-col>
                <v-col cols="9" class="pt-0 pb-0">
                  {{ firmwareDetails.rollout_status }}
                </v-col>
              </v-row>

              <v-row class="pb-0">
                <v-col cols="3" class="pt-0 pb-0">
                  Created:
                </v-col>
                <v-col cols="9" class="pt-0 pb-0">
                  {{ firmwareDetails.created_on_formatted }} <span v-if="firmwareDetails.rollout_status == 'Withdrawn'">Withdrawn: {{ firmwareDetails.withdrawn_on_formatted }}</span>
                </v-col>
              </v-row>

              <v-row class="pb-0">
                <v-col cols="3" class="pt-0 pb-0">
                  Started:
                </v-col>
                <v-col cols="9" class="pt-0 pb-0">
                  {{ firmwareDetails.rollout_start_formatted }}
                </v-col>
              </v-row>

              <v-row class="pb-0">
                <v-col cols="3" class="pt-0 pb-0">
                  Compatibility:
                </v-col>
                <v-col cols="9" class="pt-0 pb-0">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <span
                        v-bind="attrs"
                        v-on="on"
                      >{{ compatibilityRangeDisplayText }}</span>
                    </template>
                    <v-card max-width="220">
                      <v-list-item v-for="version in compatibilityRangeArray" :key="version">
                        <v-list-item-content>
                          <v-list-item-title class="highlight">{{ version }}</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-card>
                  </v-tooltip>
                  
                </v-col>
              </v-row>

              <v-row class="pb-2">
                <v-col cols="3" class="pt-0 pb-0">
                  Description:
                </v-col>
                <v-col cols="9" class="pt-0 pb-0">
                  {{ firmwareDetails.description }}
                </v-col>
              </v-row>
            </div>
          </v-col>
        </v-row>
        <v-row class="mt-6">
          <v-col cols="12">
            <div class="panel pa-3">
              <v-row>
                <v-col cols="7">
                  <v-text-field
                    v-model="searchString"
                    append-icon="mdi-magnify"
                    label="Search"
                    single-line
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col cols="5" class="pt-6">
                  <v-checkbox
                    v-model="exactMatch"
                    :label="`Exact matches only`"
                  ></v-checkbox>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="7">
                  <v-radio-group
                    v-model="searchOptions"
                    mandatory
                  >
                    <v-row>
                      <v-col cols="6">
                        <v-radio
                          label="All fields"
                          value="all"
                        ></v-radio>
                        <v-radio
                          label="IMEI"
                          value="imei"
                        ></v-radio>
                        <v-radio
                          label="Install Tag"
                          value="install_tag"
                        ></v-radio>                      
                      </v-col>

                      <v-col cols="6">
                        <v-radio
                          label="Vehicle"
                          value="vehicle_name"
                        ></v-radio>
                        <v-radio
                          label="Organisation"
                          value="org"
                        ></v-radio>
                      </v-col>
                    </v-row>
                  </v-radio-group>
                </v-col>
                <v-col cols="5" class="pt-6">
                  <v-row class="pt-12">
                    <v-col cols="6">
                      <v-btn color="primary" @click="displaySearchedDetails = false">clear</v-btn>
                    </v-col>
                    <v-col cols="6">
                      <v-btn color="primary" :disabled="!searchString.length" @click="getFirmwareRolloutDetailsSearch">go</v-btn>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </div>
          </v-col>
        </v-row>
      </v-col>

      <!-- charts container! -->
      <v-col cols="6">
        <div style="position: relative; width: 460px; height: 350px; padding-top: 40px; background: #eee">
          <!-- chart select -->
          <div style="position: absolute; width: 200px; margin-top: -30px; margin-left: 10px; z-index: 3">
            <v-select v-model="selectedChart" density="compact" label="chart type" :items="chartTypes" />
            <!-- just some messages to show if we don't have any data from the agg api. we won't have a chart to draw with no data :) -->
            <p v-if="selectedChart == 'Failure Mode' && !rolloutErrors.length">no errors to show</p>
            <p v-if="selectedChart == 'Rollout Status' && !rolloutsStatus.length">no status updates available</p>
          </div>

          <!-- chart components-->
          <div style=" position: relative; width: 460px; height: 310px';">      
            <FailureModeChart :info="rolloutErrors" v-if="selectedChart == 'Failure Mode'" />
            <RolloutStatusChart :info="rolloutsStatus" v-if="selectedChart == 'Rollout Status'" />
          </div>
        </div>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="4">
        <v-chip-group v-model="selectedFilter" multiple active-class="third--text" class="ma-4">
          <v-chip v-for="tag in filters" :key="tag">{{ tag.text }}</v-chip>
        </v-chip-group>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" class="pl-0 pr-0">
        <v-data-table 
        :headers="headers" 
        :items="filteredSet" 
        :loading="loading" 
        class="elevation-1 admin-table"
      >
        <template v-slot:item.current_state="{item}">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-avatar
                :color="statusColor(item.current_state)"
                size="20"
                v-bind="attrs"
                v-on="on"
              >
              </v-avatar>
            </template>
            <span>{{ item.current_state }}</span>
          </v-tooltip>
        </template>
      </v-data-table>
      </v-col>
      <v-col cols="12">
        <v-row>
          <v-spacer/>
          <v-col cols="8" class="vert-center">
            <div class="aux-pagination-btn">
              <v-btn text>
                <v-icon color="#0000008a" @click="setPage(1)">
                  mdi-chevron-double-left
                </v-icon>
              </v-btn>
            </div>
            <v-pagination
              v-model="selectedPage"
              :length="totalPages"
              :total-visible="7"
            ></v-pagination>
            <div class="aux-pagination-btn">
              <v-btn text>
                <v-icon color="#0000008a" @click="setPage(totalPages)">
                  mdi-chevron-double-right
                </v-icon>
              </v-btn>
            </div>
          </v-col>
          <v-col cols="1" class="pr-12">
            <v-text-field 
              v-model="selectedPage"
              hide-spin-buttons
              min="0"
              type="number"
            />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import FailureModeChart from '../tabs/charts/FailureMode.vue'
import RolloutStatusChart from '../tabs/charts/RolloutStatus.vue'

import { getFirmwareRolloutDetails, getFirmwareRolloutDetailsAgg, getFirmwareRolloutDetailsSearch } from "@/services/API.js"

import moment from "moment"

import { Logger } from "aws-amplify"
const logger = new Logger("firmware / rollout details")

export default {
  name: 'RolloutDetails',

  components: {
    FailureModeChart,
    RolloutStatusChart
  },

  props: {
    isOpen: {
      type: Boolean,
      required: false,
      default: false
    },

    firmwareDetails: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      selectedChart: 'Rollout Status',
      chartTypes: ['Rollout Status', 'Failure Mode'],
      rolloutErrors: [], // return in the agg api, an array of error reasons
      rolloutsStatus: [], // return in the agg api, current status of the rollout
      page: 1,
      totalPages: 1,
      headers: [
        { text: "IMEI", value: "imei" },
        { text: "Install Tag", value: "install_tag" },
        { text: "Assigned", value: "assigned" },
        { text: "Vehicle", value: "vehicle_name" },
        { text: "Organisation", value: "org" },
        { text: "Status", value: "current_state" },
        { text: "Last Requested", value: "last_requested_formatted" }
      ],
      rolloutDetails: [],
      searchedDetails: [],
      loading: false,
      searchString: '',
      exactMatch: true,
      searchOptions: '',
      displaySearchedDetails: false,
      selectedFilter: '',
      filters: [
        { text: 'Succeeded', val: 'Completed'},
        { text: 'Failed', val: 'Failure'},
        { text: 'Accepted', val: 'Accepted'}
      ]
    }
  },

  computed: {
    selectedPage: {
      get() { 
        return parseInt(this.page); 
      },
      set(newVal) { 
        this.page = parseInt(newVal);
      }
    },

    filteredSet () {
      if(!this.selectedFilter.length) {
        return this.tableItems
      } else {
        const filters = this.selectedFilter.map(i => this.filters[i].val)

        return this.tableItems.filter(i => filters.includes(i.current_state))
      }
    },

    compatibilityRange() {
      const ranges = this.firmwareDetails.compatibility
      let formattedString = ''

      ranges.forEach((item, index = 1) => {
        index++

        if((index < ranges.length && ranges.length == 1) || index == ranges.length - 1 || ranges.length == 1) {
          formattedString = formattedString.concat(`${item.from_version} to ${item.to_version}`)
        }
        else if (index < ranges.length) {
          formattedString = formattedString.concat(`${item.from_version} to ${item.to_version}, `)
        }
        else if(index == ranges.length) {
          formattedString = formattedString.concat(` & ${item.from_version} to ${item.to_version}`)
        }
        
      })
      return formattedString
    },

    compatibilityRangeDisplayText() {
      return this.compatibilityRange.length >= 25 ? `${this.compatibilityRange.substring(0, 25)}...` : this.compatibilityRange
    },

    compatibilityRangeArray() {
      const ranges = this.firmwareDetails.compatibility
      let formattedItems = []

      ranges.forEach((item) => {
        formattedItems.push(`${item.from_version} to ${item.to_version}`)
      })

      return formattedItems
    },

    tableItems() {
      return this.displaySearchedDetails ? this.searchedDetails : this.rolloutDetails
    }
  },

  watch: {
    page() {
      if(this.page > 0 && this.page <= this.totalPages) {
        if(this.displaySearchedDetails) {
          this.getFirmwareRolloutDetailsSearch()
        } else {
          this.queryWrapper()
        }
      }
    }
  },

  mounted() {
    this.queryWrapper()
  },

  methods: {
    async getFirmwareRolloutDetailsSearch() {
      this.displaySearchedDetails = true

      try {
        let searchParams =  `attribute=${this.searchOptions}&value=${this.searchString}`

        /*
        if(this.searchOptions == 'all') {
          searchParams = `attribute=org&value=${this.searchString}&attribute=vehicle_name&value=${this.searchString}&attribute=install_tag&value=${this.searchString}&attribute=all&value=${this.searchString}`
        } else {
          searchParams = `attribute=${this.searchOptions}&value=${this.searchString}`
        }
        */

        if(this.exactMatch) {
          searchParams = `${searchParams}&exact_match=true`
        }
        const details = await getFirmwareRolloutDetailsSearch(this.firmwareDetails.rollout_id, this.page, searchParams)

        this.searchedDetails = details.detailed_rollout.map(item => ({
          ...item,
          last_requested_formatted: moment(item.last_requested).utc().format('D MMM YYYY HH:mm')
        }))
      } catch {
        throw new Error('Something went wrong returning search results.')
      }
    },

    queryWrapper() {
      this.loading = true
      Promise.all([this.getFirmwareRolloutDetails(), this.getFirmwareRolloutDetailsAgg()])
      .then(() => {
        this.loading = false
      })
      .catch(() => {
        this.loading = false
        throw new Error('Something went wrong.')
      })
    },

    async getFirmwareRolloutDetails() {
      try {
        const details = await getFirmwareRolloutDetails(this.firmwareDetails.rollout_id, this.page)

        logger.info('details', details.detailed_rollout)
        
        this.rolloutDetails = details.detailed_rollout.map(item => ({
          last_requested_formatted: moment(item.last_requested).utc().format('D MMM YYYY HH:mm'),
          ...item
        }))
        this.page = details.page_num
        this.totalPages = details.page_count
      } catch {
        throw new Error('There was a problem getting rollout detail information')
      }
      
    },

    async getFirmwareRolloutDetailsAgg() {
      const aggDetails = await getFirmwareRolloutDetailsAgg(this.firmwareDetails.rollout_id)
      this.rolloutsStatus = aggDetails.current_state
      this.rolloutErrors = aggDetails.failure_reason
      logger.info('aggDetails', aggDetails)
    },

    statusColor(val) {
      if(val == 'Accepted') {
        return '#FFA500'
      }
      if(val == 'Completed') {
        return '#18a31b'
      }
      if(val == 'Failure') {
        return '#cc0000'
      }
    }
  }
}
</script>

<style lang="scss">
  .panel {
    background: rgb(238, 238, 238);
    font-size: 14px;
    border-radius: 5px;
  }
  .vert-center {
    align-items: center;
    display: flex;
    justify-content: flex-end;
  }

  .aux-pagination-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 0;
    margin: 0;
  }

  .highlight {
    color: #0f74bb;
  }

  .v-input--selection-controls .v-radio > .v-label {
    font-size: 14px !important;
  }
  .v-input--selection-controls .v-input__slot > .v-label, .v-input--selection-controls .v-radio > .v-label {
    font-size: 14px !important;
  }
</style>